// extracted by mini-css-extract-plugin
module.exports = {"container":"e_FA","icon":"e_GA"};